import { render, staticRenderFns } from "./FrameDesignSelector.vue?vue&type=template&id=d6c2a090&lang=pug"
import script from "./FrameDesignSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./FrameDesignSelector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports